"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const EditIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M18.093 2.29a.997.997 0 00-1.407 0L7.65 11.297a.992.992 0 00-.293.703v3.603c0 .548.446.993.996.993h3.615a.997.997 0 00.703-.29l9.038-9.007a.993.993 0 000-1.406L18.093 2.29zM9.347 14.61v-2.198l8.043-8.015 2.206 2.199-8.041 8.013H9.347z", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "M3.99 6.596a.81.81 0 01.813-.808h4.826a.994.994 0 100-1.987H4.803A2.799 2.799 0 002 6.596v12.61A2.799 2.799 0 004.803 22h12.653a2.799 2.799 0 002.803-2.795v-4.81a.994.994 0 00-1.991 0v4.81a.81.81 0 01-.812.808H4.803a.81.81 0 01-.812-.808V6.596z" })] }));
exports.default = (0, IconContainer_1.default)(EditIcon);
//# sourceMappingURL=index.js.map